import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../../../services/faq.service';
import {FaqArticle} from '../../../../model/faq-article';
import {FaqCategoryService} from '../../../../services/faq-category.service';
import {FaqCategory} from '../../../../model/FaqCategory';
import {RouterLink} from "@angular/router";
import {SortPipe} from "../../../common/SortPipe";
import {UrlDecodePipe} from "../../../common/UrlDecodePipe";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {DashBlockComponent} from "../dash-block.component";


@Component({
    selector: 'app-dash-block-faq',
    templateUrl: './dash-block-faq.component.html',
    imports: [
    RouterLink,
    SortPipe,
    UrlDecodePipe,
    BadgeComponent,
    DashBlockComponent
],
    styleUrls: ['./dash-block-faq.component.css']
})
export class DashBlockFaqComponent implements OnInit {

  articles: FaqArticle[] = undefined;
  categories: FaqCategory[];
  error = false;

  constructor(private faqService: FaqService,
              private faqCategoryService: FaqCategoryService) {
  }

  ngOnInit(): void {
    this.faqCategoryService.getObjects().subscribe(cats => {
      this.categories = cats;
    });
    this.faqService.getObjects().subscribe(data => {
      this.articles = data;
    }, () => {
      this.error = true;
    });
  }

  getCategoryById(id: number): FaqCategory {
    return this.categories.find(c => +c.categoryId === id);
  }

}
